export default __webpack_public_path__ + "static/press_release_thumbnail-1707953bd8c7c180efd376d38897d6d9.jpg";